import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  standalone: false,
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent {
  features = [
    {
      icon: '/assets/images/svg-icons/Web3Toolkit.svg',
      title: 'about.card_1_title',
      desc: 'about.card_1_desc',
    },
    {
      icon: '/assets/images/svg-icons/audit-icon.svg',
      title: 'about.card_2_title',
      desc: 'about.card_2_desc',
    },
    {
      icon: '/assets/images/svg-icons/phase-complete.svg',
      title: 'about.card_3_title',
      desc: 'about.card_3_desc',
    },
  ];

  stats = [
    { value: 'about.stat_1_val', label: 'about.stat_1_label' },
    { value: 'about.stat_2_val', label: 'about.stat_2_label' },
    { value: 'about.stat_3_val', label: 'about.stat_3_label' },
    { value: 'about.stat_4_val', label: 'about.stat_4_label' },
  ];

  highlights = [
    'about.bullet_1',
    'about.bullet_2',
    'about.bullet_3',
  ];
}
